module.exports = __webpack_public_path__ + "static/media/files.4561e0a3.svg";